import { render, staticRenderFns } from "./ActionDownload.vue?vue&type=template&id=113f6d1c"
import script from "./ActionDownload.vue?vue&type=script&lang=js"
export * from "./ActionDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports